import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UseUpdateOrganisationIsTrialPackage {
  isUsingTrialPackage: boolean;
}

export const useUpdateOrganisationIsTrialPackage = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UseUpdateOrganisationIsTrialPackage) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data });
      const response = await fetch(`${APIBaseChronos}/api/org/${orgId}`, fetchConfig);
      if (!response.ok) throw new Error('Failed to update isTrialPackage');
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, orgId]);
      toast.success('Onboarding package setting successfully updated');
    },
    onError: () => {
      toast.error('Failed to update onboarding package setting');
    },
  });
};
